var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1530_3663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6205 17.2316C18.3075 17.9548 17.9369 18.6205 17.5076 19.2325C16.9224 20.0669 16.4433 20.6444 16.074 20.9652C15.5016 21.4916 14.8882 21.7612 14.2315 21.7765C13.76 21.7765 13.1914 21.6424 12.5295 21.3702C11.8655 21.0993 11.2552 20.9652 10.6973 20.9652C10.1121 20.9652 9.48443 21.0993 8.81311 21.3702C8.14076 21.6424 7.59913 21.7842 7.18501 21.7982C6.55521 21.8251 5.92746 21.5478 5.30086 20.9652C4.90092 20.6163 4.40069 20.0184 3.80143 19.1712C3.15847 18.2666 2.62987 17.2176 2.21576 16.0216C1.77225 14.7298 1.54993 13.4789 1.54993 12.2679C1.54993 10.8806 1.84968 9.68414 2.45009 8.6815C2.92196 7.87614 3.54972 7.24085 4.3354 6.77447C5.12108 6.3081 5.97001 6.07044 6.88423 6.05523C7.38447 6.05523 8.04046 6.20997 8.85565 6.51407C9.66855 6.81919 10.1905 6.97393 10.4194 6.97393C10.5904 6.97393 11.1703 6.793 12.1532 6.4323C13.0828 6.09778 13.8673 5.95928 14.51 6.01384C16.2516 6.15439 17.56 6.84092 18.4301 8.07777C16.8726 9.0215 16.1021 10.3433 16.1174 12.039C16.1315 13.3598 16.6106 14.4589 17.5523 15.3316C17.9791 15.7367 18.4557 16.0497 18.986 16.272C18.871 16.6055 18.7496 16.925 18.6205 17.2316ZM14.6263 1.51415C14.6263 2.54939 14.2481 3.51599 13.4942 4.41066C12.5845 5.47425 11.4841 6.08884 10.2908 5.99186C10.2756 5.86766 10.2668 5.73695 10.2668 5.59959C10.2668 4.60577 10.6994 3.54218 11.4677 2.67255C11.8513 2.23224 12.3392 1.86613 12.9307 1.57408C13.5211 1.28638 14.0794 1.12728 14.6046 1.10004C14.6199 1.23843 14.6263 1.37683 14.6263 1.51414V1.51415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1530_3663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(0.199951 0.200012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.19dbfe8c3a1f7c345f0cc8f7ed65e42b.svg";
export { ForwardRef as ReactComponent };